import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./footer";

const Taskmanagment = () => {
  const [pageData, setPageData] = useState(null);

  const fetchSeoData = async () => {
    try {
      const response = await fetch("/seo.json");
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        const pages = data.data[0]?.pages || [];

        console.log("Pages Data:", pages);

        const faqPageData = pages.find((page) => page.page_id === "12");

        if (faqPageData) {
          console.log("FAQ Page Data:", faqPageData.basic_settings.tittle);
          setPageData(faqPageData);
        } else {
          console.log("FAQ page not found");
        }
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  };

  useEffect(() => {
    fetchSeoData();
    window.scrollTo({ top: 0, behavior: "smooth" });
    const script = document.createElement("script");
    script.src = "./on_seo.js";
    script.type = "module";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <h1 className="text-center mt-4 px-5 mx-5">
        Best Task Management Software in India 2025 – Organize & Track Workflows
        Efficiently
      </h1>
      <div className="d-flex justify-content-center">
        <img
          src="https://billpunch.com/billpunchImages/Workday%20a%20Breeze.png"
          style={{ height: "50vh" }}
        />
      </div>
      <div className="row mt-md-2">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <h2>Simplify Task Planning & Enhance Productivity</h2>
          <p>
            Tasks complete effectively, enhancing productivity, and then
            eventually achieving deadlines. BillPunch Task Management Software
            is the Internet-based, cloud-hosted application for real-time
            assignment, tracking, and management of any task. BillPunch Task
            Management Software automated task tracking to ensure accountability
            while executing both daily operations and teamwork or client
            projects.
          </p>

          <h5>BillPunch's Task Management Software Key Features</h5>

          <h5>Smart Creation & Assignment of Tasks</h5>
          <ul>
            <li>
              Create tasks to assign them with deadlines and dependencies using
              drag-and-drop management for organization.
            </li>
          </ul>

          <h5>Real-Time Collaboration & Notifications</h5>
          <ul>
            <li>
              Instant task updates and reminders are sent to team members.
            </li>
            <li>Share comments and files within the application.</li>
          </ul>

          <h5>Automated Workflow Manager:</h5>
          <ul>
            <li>
              You can make dependencies between tasks and automate repetitive
              actions.
            </li>
          </ul>

          <h5>Track time and productivity features: </h5>
          <ul>
            <li>
              Improving on the efficiency with which you track time done against
              your tasks.
            </li>
            <li>
              Extend detailed reporting against individual activity and team
              performance.
            </li>
          </ul>

          <h5>Mobile Support & Cloud Synchronization:</h5>
          <ul>
            <li>Access tasks across devices with mobile app support</li>
            <li>Cloud synchronization on tasks for remote teams</li>
          </ul>

          <h5>Why BillPunch Offers Task Management?</h5>
          <ul>
            <li>Smart task automation to boost team productivity.</li>
            <li>
              Collaborative environment enhanced with real-time task tracking.
            </li>
            <li>
              Become more efficient through detailed performance analytics.
            </li>
            <li>
              Reduce workload stress via the automation of repetitive tasks.
            </li>
          </ul>
        </div>

        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Taskmanagment;
